module.exports = __webpack_public_path__ + "media/images/e-bilet/question_return-cb5896cf6bd878ebb7a7b572977b816a.svg";